<template>
  <div class="app-shell">
    <SiteHeader />
    <main class="app-main">
      <router-view v-slot="{ Component }">
        <transition name="page" mode="out-in">
          <component :is="Component" />
        </transition>
      </router-view>
    </main>
    <SiteFooter />
  </div>
</template>

<script>
import SiteHeader from "@/components/SiteHeader.vue";
import SiteFooter from "@/components/SiteFooter.vue";

export default {
  name: "App",
  components: { SiteHeader, SiteFooter },
};
</script>

<style>
.app-main {
  min-height: 60vh;
}
</style>
